module.exports = __webpack_public_path__ + "img/fachadaalex3.4ed1b1b7.png";